import { GraphQLCampaign } from 'modules/campaignIndex/domainTypes';
import { parseDate } from 'utils/datetime';

export const sortByDescendingEndDate = (campaigns: GraphQLCampaign[]): GraphQLCampaign[] => {
  return [...campaigns].sort(({ endedAt: left }, { endedAt: right }) => {
    if (left === null) return 1;
    if (right === null) return -1;
    if (left && right) {
      return parseDate(right).getTime() - parseDate(left).getTime();
    }
    return 0;
  });
};
